import { InoculumConcentrationUnitsType, MassUnitsType, PowerUnitsType, RateChangeCoefficientsType, RateCoefficientsType, SpecificPowerUnitsType, StirringUnitsType, TemperatureChangeUnitsType, TemperatureUnitsType, TimeUnitsType, VolumeUnitsType, } from "store/recipe/recipe.types";
export var InputDirection;
(function (InputDirection) {
    InputDirection["LEFT"] = "left";
    InputDirection["RIGHT"] = "right";
})(InputDirection || (InputDirection = {}));
export var GlobalEntityType;
(function (GlobalEntityType) {
    GlobalEntityType["PsWorkspace"] = "PointScalingWorkspace";
    GlobalEntityType["RsWorkspace"] = "RecipeScalingWorkspace";
    GlobalEntityType["CellModel"] = "CellModel";
    GlobalEntityType["Recipe"] = "Recipe";
    GlobalEntityType["ProcessData"] = "ProcessData";
})(GlobalEntityType || (GlobalEntityType = {}));
export var RsWorkspaceEntityType;
(function (RsWorkspaceEntityType) {
    RsWorkspaceEntityType["ResultSet"] = "ResultSet";
    RsWorkspaceEntityType["ResultSetElement"] = "ResultSetElement";
    RsWorkspaceEntityType["Simulation"] = "Simulation";
    RsWorkspaceEntityType["Insight"] = "Insight";
    RsWorkspaceEntityType["Optimization"] = "Optimization";
    RsWorkspaceEntityType["CustomVariable"] = "Custom Variable";
    RsWorkspaceEntityType["TabularView"] = "Tabular view";
    RsWorkspaceEntityType["LineGraph"] = "Line graph";
    RsWorkspaceEntityType["SpaceViewer"] = "Space viewer";
    RsWorkspaceEntityType["ProcessDataViewer"] = "Process data viewer";
})(RsWorkspaceEntityType || (RsWorkspaceEntityType = {}));
export const GLOBAL_ENTITIES_ITEM_LABELS = {
    [GlobalEntityType.CellModel]: { label: "Cell Model", title: "Cell Models" },
    [GlobalEntityType.Recipe]: { label: "Recipe", title: "Recipes" },
    [GlobalEntityType.RsWorkspace]: { label: "Workspace", title: "Workspaces" },
    [GlobalEntityType.PsWorkspace]: { label: "Workspace", title: "Workspaces" },
    [GlobalEntityType.ProcessData]: { label: "Process Data", title: "Process Data" },
};
export var TimeUnits;
(function (TimeUnits) {
    TimeUnits["seconds"] = "seconds";
    TimeUnits["minutes"] = "minutes";
    TimeUnits["hours"] = "hours";
    TimeUnits["days"] = "days";
})(TimeUnits || (TimeUnits = {}));
export var SpaceviewerAxisType;
(function (SpaceviewerAxisType) {
    SpaceviewerAxisType["FLOAT"] = "float";
    SpaceviewerAxisType["INTEGER"] = "integer";
})(SpaceviewerAxisType || (SpaceviewerAxisType = {}));
export var Completeness;
(function (Completeness) {
    Completeness["Incomplete"] = "incomplete";
    Completeness["Complete"] = "complete";
    Completeness["Errored"] = "errored";
})(Completeness || (Completeness = {}));
export var SearchDirection;
(function (SearchDirection) {
    SearchDirection["Forward"] = "Forward";
    SearchDirection["Back"] = "Back";
})(SearchDirection || (SearchDirection = {}));
export var CutType;
(function (CutType) {
    CutType["TimeSeries"] = "TimeSeries";
    CutType["PointInTime"] = "PointInTime";
})(CutType || (CutType = {}));
export var TimestampType;
(function (TimestampType) {
    TimestampType["Start"] = "Start";
    TimestampType["End"] = "End";
    TimestampType["Custom"] = "Custom";
    TimestampType["CurrentTime"] = "CurrentTime";
})(TimestampType || (TimestampType = {}));
export var DialogStatus;
(function (DialogStatus) {
    DialogStatus["OPENED"] = "opened";
    DialogStatus["CLOSED"] = "closed";
    DialogStatus["PENDING"] = "pending";
})(DialogStatus || (DialogStatus = {}));
export var LockedDialogModes;
(function (LockedDialogModes) {
    LockedDialogModes["DISABLED"] = "disabled";
    LockedDialogModes["LOCKED"] = "locked";
    LockedDialogModes["LOCKED_UNSAVED"] = "locked_unsaved";
    LockedDialogModes["NOT_OWNER"] = "not_owner";
    LockedDialogModes["RECOVERY"] = "recovery";
    LockedDialogModes["SAMPLE"] = "sample";
})(LockedDialogModes || (LockedDialogModes = {}));
export const ConversionFactors = {
    //TimeUnitsType
    [TimeUnitsType.Hr]: 60,
    [TimeUnitsType.Min]: 1,
    [TimeUnitsType.S]: 0.016666667,
    //RateCoefficientsType
    [RateCoefficientsType.Hr1]: 60,
    [RateCoefficientsType.Min1]: 1,
    [RateCoefficientsType.S1]: 0.016666667,
    //RateChangeCoefficientsType
    [RateChangeCoefficientsType.Hr2]: 60,
    [RateChangeCoefficientsType.Min2]: 1,
    [RateChangeCoefficientsType.S2]: 0.016666667,
    //TemperatureUnitsType
    [TemperatureUnitsType.C]: 60,
    [TemperatureUnitsType.F]: 1,
    //TemperatureChangeUnitsType
    [TemperatureChangeUnitsType.Chr1]: 60,
    [TemperatureChangeUnitsType.Cmin1]: 1,
    [TemperatureChangeUnitsType.Fhr1]: 60,
    [TemperatureChangeUnitsType.Fmin1]: 1,
    //VolumeUnitsType
    [VolumeUnitsType.L]: 1,
    [VolumeUnitsType.ML]: 0.001,
    [VolumeUnitsType.MicroL]: 0.000001,
    //MassUnitsType
    [MassUnitsType.G]: 1,
    [MassUnitsType.Mg]: 0.001,
    [MassUnitsType.Microg]: 0.000001,
    //PowerUnitsType
    [PowerUnitsType.KW]: 1,
    [PowerUnitsType.W]: 0.001,
    //SpecificPowerUnitsType
    [SpecificPowerUnitsType.KWm3]: 1,
    [SpecificPowerUnitsType.Wm3]: 0.001,
    //InoculumConcentrationUnitsType
    [InoculumConcentrationUnitsType.CELLS_PER_ML]: 1,
    [InoculumConcentrationUnitsType.MILLION_CELLS_PER_ML]: 1000000,
    //StirringUnitsType
    [StirringUnitsType.Rpm]: 1,
    [StirringUnitsType.Rps]: 60,
};
